import { render } from "./App.vue?vue&type=template&id=12713fb0&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=12713fb0&lang=scss&scoped=true"

import exportComponent from "/Users/adrian/vue/laolife/newlife-web-about/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12713fb0"]])

export default __exports__